import { useId } from "react";

import { cn } from "@/lib/utils";

export function CouponsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-4.5", className)}
      fill="none"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M1.322 14.247H5.25V3.865H1.322c-.35 0-.687.134-.935.371A1.24 1.24 0 000 5.132v1.44c0 .194.14.361.338.402a2.25 2.25 0 011.257.747c.318.378.492.849.494 1.335a2.083 2.083 0 01-.493 1.336 2.246 2.246 0 01-1.258.746.416.416 0 00-.338.403v1.44c0 .336.14.658.387.895.248.238.584.37.935.37zm4.785 0H16.68c.35 0 .686-.134.934-.372.247-.237.387-.559.387-.895V5.132c0-.336-.14-.658-.387-.895a1.352 1.352 0 00-.934-.372H6.107v10.382z"
        fill={`url(#${id})`}
        fillRule="evenodd"
      />
      <path
        d="M12.416 10.412a1.31 1.31 0 01.432-.987c.14-.13.297-.23.473-.3a1.51 1.51 0 01.584-.114c.209 0 .4.038.577.113.181.07.339.17.472.301.139.126.246.274.32.445.08.165.12.346.12.542 0 .195-.04.379-.12.55a1.392 1.392 0 01-.32.444c-.133.125-.29.225-.472.3-.176.07-.368.106-.577.106-.208 0-.403-.035-.584-.105a1.689 1.689 0 01-.473-.302 1.578 1.578 0 01-.32-.444 1.355 1.355 0 01-.112-.55zm2.21 0a.637.637 0 00-.208-.482.72.72 0 00-.513-.196.72.72 0 00-.512.196.635.635 0 00-.208.482c0 .19.07.351.208.481a.72.72 0 00.512.196.72.72 0 00.513-.196.635.635 0 00.208-.481zm-6.013-2.71c0-.197.038-.377.112-.543a1.454 1.454 0 01.793-.745 1.51 1.51 0 01.584-.113c.209 0 .4.037.577.113.181.07.339.17.472.3.139.126.246.274.32.445.08.166.12.346.12.542 0 .196-.04.38-.12.55a1.392 1.392 0 01-.32.444c-.133.125-.29.226-.472.301-.176.07-.368.106-.577.106-.208 0-.403-.036-.584-.106a1.688 1.688 0 01-.472-.301 1.578 1.578 0 01-.32-.444 1.355 1.355 0 01-.113-.55zm2.21 0a.64.64 0 00-.208-.483.72.72 0 00-.513-.195.72.72 0 00-.512.195.635.635 0 00-.208.482c0 .19.07.352.208.482a.72.72 0 00.512.196.72.72 0 00.513-.196.635.635 0 00.208-.482zm2.522-1.552l.664.286-3.33 5.527-.665-.286 3.33-5.527z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="1.601"
          x2="14.616"
          y1="13.649"
          y2="5.892"
        >
          <stop stopColor="#6315ea" />
          <stop offset="1" stopColor="#ef67b0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function DropdownIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[7px] w-2.5 text-white", className)}
      fill="none"
      viewBox="0 0 10 7"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 1.5l4 4 4-4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}
